import checkValidSepaInput from '@/modules/receipt/_helpers/checkValidSepaInput'

const checkValidReceiptNumberInput = (value): boolean =>
  checkValidSepaInput(String(value ?? '').replace(/_/g, ''))

export default checkValidReceiptNumberInput
